import './animations/bar-chart-animation';
import './animations/bubble-animation';
import './animations/fade-in-animation';
import './animations/clip-animation';
import './animations/pie-animation';